import { createReducer } from '@reduxjs/toolkit'
import { IStateCurrentRole } from './TReducer'
import { Actions_CurrentRole } from './Actions'

const initialState: IStateCurrentRole = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerCurrentRole = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_CurrentRole.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_CurrentRole.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_CurrentRole.store.saveCurrentRole, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
    .addCase(Actions_CurrentRole.store.clearCurrentRole, (state) => {
      state.data = null
    })
})

export default ReducerCurrentRole
